<div class="file-upload">
  @if ((imageUrl === null || imageUrl === '') && disabled === false) {
    <a href="javascript:void(0)" class="upload-icon" (click)="triggerFileInput()" (keydown)="triggerFileInput()" [attr.aria-label]="imageUrl ? 'Cambiar imagen' : 'Subir imagen'">
      <mat-icon fontIcon="add_photo_alternate" />
    </a>
  } @else {
    <img *ngIf="imageUrl" [src]="imageUrl" alt="Uploaded" class="img_upload" />
    @if (isDeleteImage() && disabled === false) {
      <a href="javascript:void(0)" class="deleteImage" (click)="dropImage()" (keydown)="dropImage()" [attr.aria-label]="'Eliminar imagen'">
        <mat-icon fontIcon="disabled_by_default" />
      </a>
    }
  }
  <input #fileInput id="fileUpload" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg" style="display: none" />
</div>
